import { render, staticRenderFns } from "./AssetTypes.vue?vue&type=template&id=603a6440"
import script from "./AssetTypes.vue?vue&type=script&lang=js"
export * from "./AssetTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports